import type { queryOptions as tanstackQueryOptions } from "@tanstack/solid-query"

export const queryOptions = ((options) => options) as typeof tanstackQueryOptions
